import { fetchWithTimeout } from './utils';
export const RETRYABLE_HTTP_STATUSES = new Set([429, 500, 502, 503, 504]);
const DEFAULT_MAX_ATTEMPTS = 3;
const DEFAULT_BASE_DELAY_MS = 300;
const DEFAULT_MAX_DELAY_MS = 2000;
const DEFAULT_TIMEOUT_MS = 10000;
export function isRetryableHttpStatus(status) {
    return RETRYABLE_HTTP_STATUSES.has(status);
}
function sleep(ms) {
    return new Promise((resolve) => setTimeout(resolve, ms));
}
export function getRetryDelayMs(response, attempt, baseDelayMs, maxDelayMs) {
    if (response?.status === 429) {
        const retryAfter = response.headers.get('Retry-After');
        if (retryAfter) {
            const seconds = Number(retryAfter);
            if (!Number.isNaN(seconds)) {
                return Math.min(seconds * 1000, maxDelayMs);
            }
        }
    }
    const exponential = baseDelayMs * Math.pow(2, attempt);
    const jitter = exponential * 0.25 * (Math.random() * 2 - 1);
    return Math.min(Math.max(exponential + jitter, 0), maxDelayMs);
}
export async function retryFetch(url, options = {}, retryOptions = {}) {
    const { maxAttempts = DEFAULT_MAX_ATTEMPTS, baseDelayMs = DEFAULT_BASE_DELAY_MS, maxDelayMs = DEFAULT_MAX_DELAY_MS, timeoutMs = DEFAULT_TIMEOUT_MS, shouldRetryResponse = (response) => isRetryableHttpStatus(response.status), } = retryOptions;
    let lastError;
    for (let attempt = 0; attempt < maxAttempts; attempt++) {
        try {
            const response = await fetchWithTimeout(url, { ...options, timeout: timeoutMs });
            if (response.ok || !shouldRetryResponse(response) || attempt === maxAttempts - 1) {
                return response;
            }
            await sleep(getRetryDelayMs(response, attempt, baseDelayMs, maxDelayMs));
        }
        catch (error) {
            lastError = error;
            if (attempt === maxAttempts - 1) {
                throw error;
            }
            await sleep(getRetryDelayMs(null, attempt, baseDelayMs, maxDelayMs));
        }
    }
    throw lastError;
}
